import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFamilyNameList } from "../../fetch/fetchClassificationItems";
import FaultIdCell from "./FaultIdCell";
import FaultItemFamilyCell from "./FaultItemFamilyCell";
import FaultNameCell from "./FaultNameCell";
import { usePhoneMode } from "../../hooks";

export default function FaultRow({ fault, setSelectedFault }) {
    const { phoneMode } = usePhoneMode();
    const navigate = useNavigate();
    const { familyNameId: filteredFamilyNameId } = useParams();
    const { familyNames: sourceFamilyNames } = useFamilyNameList(true);

    const {
        universalFaultId, universalConditionId, failureDescription,
        familyNames, moduleTypes, engineeringNames, faultName
    } = fault;
    const legacy = universalFaultId == null || universalConditionId == null;

    let moduleParam = '';
    if (!!moduleTypes && moduleTypes.length === 1) {
        moduleParam = `?moduleTypeId=${moduleTypes[0]}`;
    }

    let viewUrl = null;
    if (!!filteredFamilyNameId) {
        viewUrl = !legacy ?
            `/literature/fault/${filteredFamilyNameId}/${universalFaultId}-${universalConditionId}${moduleParam}` :
            `/literature/fault/legacy/${filteredFamilyNameId}/${engineeringNames[0]}`;
    } else if (familyNames.length === 1) {
        const matchingFamily = sourceFamilyNames.filter(it => familyNames[0].indexOf(it.name) >= 0)[0];
        if (!!matchingFamily) {
            viewUrl = !legacy ?
                `/literature/fault/${matchingFamily.id}/${universalFaultId}-${universalConditionId}${moduleParam}` :
                `/literature/fault/legacy/${matchingFamily.id}/${engineeringNames[0]}`;
        }
        else {
            console.log('family not found', fault);
        }
    }

    const handleFaultClick = (event) => {
        event.stopPropagation();
        if (!viewUrl && familyNames.length > 0) {
            setSelectedFault(fault);
        } else if (!!viewUrl) {
            navigate(viewUrl);
        }
    };

    return (
        <>
            <TableRow onClick={handleFaultClick}>
                <FaultIdCell
                    universalFaultId={universalFaultId}
                    universalConditionId={universalConditionId}
                    legacy={legacy}
                    onClick={handleFaultClick}
                />
                <FaultNameCell
                    faultName={faultName}
                    engineeringNames={engineeringNames}
                    legacy={legacy}
                    onClick={handleFaultClick}
                />
                {!!filteredFamilyNameId && !phoneMode ? (
                    <TableCell>
                        <FaultItemFamilyCell fault={fault} />
                    </TableCell>
                ) : null}
                {!phoneMode ? <TableCell>{failureDescription}</TableCell> : null}
            </TableRow>
            {phoneMode ? (
                <TableRow onClick={handleFaultClick}>
                    <TableCell colSpan={2}>{failureDescription}</TableCell>
                </TableRow>
            ) : null}
        </>
    )
}